"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

function fetch(_ref) {
  var objectType = _ref.objectType;
  var url = "integrators/v1/sales-sidebar?objectType=" + objectType;
  return (0, _ImmutableAPI.get)(url).catch(function (err) {
    if (err.status === 404) {
      return _LoadingStatus.EMPTY;
    }

    throw err;
  });
}